import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import { 
  setBoardInfo
} from '../redux/boardInfo'

function * changeInfo (action, apiMethod, apiArgs) {
  const optimisticAction = yield optimisticPut(action)

  try {
    yield call(apiAction, apiMethod, apiArgs)

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}

export default function * requestChangeBoardInfo (action) {
  const { id, responsibleUserId, startDate, endDate, description, estimatedBudget } = action.payload

  if (responsibleUserId) {
    yield changeInfo(
      setBoardInfo({
        id,
        responsibleUserId
      }),
      'SetBoardResponsibleUser',
      {
        boardId: id,
        userId: responsibleUserId
      }
    ) 
  } else if (responsibleUserId === null) {
    yield changeInfo(
      setBoardInfo({
        id,
        responsibleUserId
      }),
      'RemoveBoardResponsibleUser',
      {
        boardId: id
      }
    ) 
  }

  if (startDate) {
    yield changeInfo(
      setBoardInfo({
        id,
        startDate
      }),
      'SetBoardStartDate',
      {
        boardId: id,
        timestamp: startDate
      }
    ) 
  } else if (startDate === null) {
    yield changeInfo(
      setBoardInfo({
        id,
        startDate
      }),
      'RemoveBoardStartDate',
      {
        boardId: id
      }
    ) 
  }

  if (endDate) {
    yield changeInfo(
      setBoardInfo({
        id,
        endDate
      }),
      'SetBoardEndDate',
      {
        boardId: id,
        timestamp: endDate
      }
    )
  } else if (endDate === null) {
    yield changeInfo(
      setBoardInfo({
        id,
        endDate
      }),
      'RemoveBoardEndDate',
      {
        boardId: id
      }
    ) 
  }

  if (description) {
    yield changeInfo(
      setBoardInfo({
        id,
        description
      }),
      'SetBoardDescription',
      {
        boardId: id,
        rtMessage: description
      }
    )
  }

  if (estimatedBudget && estimatedBudget.value) {
    yield changeInfo(
      setBoardInfo({
        id,
        estimatedBudget
      }),
      'SetBoardEstimatedBudget',
      {
        boardId: id,
        value: estimatedBudget.value,
        currency: estimatedBudget.currency
      }
    )
  } else if (estimatedBudget && !estimatedBudget.value) {
    yield changeInfo(
      setBoardInfo({
        id,
        estimatedBudget
      }),
      'RemoveBoardEstimatedBudget',
      {
        boardId: id
      }
    ) 
  }
}
